import { render, staticRenderFns } from "./mount-pleasant-phase-3.vue?vue&type=template&id=4a37849d&"
import script from "./mount-pleasant-phase-3.vue?vue&type=script&lang=js&"
export * from "./mount-pleasant-phase-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports